/**
 * Circular profile avatar — toolbar (sm) or menu header (lg).
 */
import { useEffect, useState } from "preact/hooks";
import { profileInitials, type VeraUserProfile } from "../auth/userProfile";

const SIZES = { sm: 28, lg: 56 } as const;

export function ProfileAvatar({
  profile,
  size = "sm",
}: {
  profile: VeraUserProfile;
  size?: keyof typeof SIZES;
}) {
  const px = SIZES[size];
  const fontSize = size === "lg" ? 18 : 11;
  const initials = profileInitials(profile);
  const [pictureFailed, setPictureFailed] = useState(false);

  useEffect(() => {
    setPictureFailed(false);
  }, [profile.picture]);

  const shell = {
    width: px,
    height: px,
    minWidth: px,
    minHeight: px,
    borderRadius: "50%",
    overflow: "hidden" as const,
    flexShrink: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    border: "2px solid var(--vera-border)",
    boxSizing: "border-box" as const,
  };

  if (profile.picture && !pictureFailed) {
    return (
      <span style={shell} aria-hidden>
        <img
          src={profile.picture}
          alt=""
          width={px}
          height={px}
          onError={() => setPictureFailed(true)}
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            display: "block",
            borderRadius: "50%",
          }}
        />
      </span>
    );
  }

  return (
    <span
      aria-hidden
      style={{
        ...shell,
        background: "var(--vera-accent)",
        color: "#fff",
        fontSize,
        fontWeight: 600,
      }}
    >
      {initials}
    </span>
  );
}
